import React, { useContext } from 'react'
import {
  Sheet,
  PAYPAL_THEME,
  FocusFlow,
  IconButton,
  ArrowLeftIcon,
  ThemeWrapper,
} from '@paypalcorp/pp-react'
import { MessageFormat } from '@paypalcorp/worldready'
import {
  Context as WorldReadyContext,
  Message,
} from '@paypalcorp/worldready-react'
import { arrayOf, bool, element, func, object, string } from 'prop-types'

// components
import CreateComponent from './CreateComponent'
import serverData from '../utils/server-data'

const { isMobile, isNative, locality = {} } = serverData,
  directionality = locality.directionality || 'ltr'

const PrivacyModal = ({
  childProps,
  children,
  hideCloseBtn,
  id,
  isFlow,
  isModalOpen,
  onBackButtonClick,
  onCloseModal,
  shouldShowBackBtn,
  showPPlogo,
  transitionOnClose,
  slides = [],
}) => {
  const isFocusFlow = isFlow && (isMobile || isNative)
  const worldReady = useContext(WorldReadyContext)
  const renderChildren = () => React.Children.map(children, (child) => child)
  const noCloseButton = isFlow && hideCloseBtn
  const showLogo = isFlow && showPPlogo
  const style = { direction: directionality }
  const { title, noPadding = true } = childProps

  const action = isFlow && shouldShowBackBtn && (
    <IconButton
      svgIconComponent={ArrowLeftIcon}
      buttonType="tertiary"
      onClick={onBackButtonClick}
    >
      <Message id="app.navigation.backLink" />
    </IconButton>
  )

  const render = () =>
    (isFlow && slides.length && <CreateComponent {...childProps} />) ||
    (isFlow && renderChildren()) || <CreateComponent {...childProps} />

  return (
    <ThemeWrapper theme={PAYPAL_THEME}>
      {isFocusFlow ? (
        <FocusFlow
          id={id}
          title={title}
          onClose={onCloseModal}
          style={style}
          action={action}
          showLogo={showLogo}
          closeButtonLabel={new MessageFormat(worldReady, {
            id: `app.modal.closeButton`,
          }).format()}
          closeButtonProps={{
            id: noCloseButton
              ? 'focus-flow-hide-close'
              : 'privacyModalCloseIconButton',
          }}
        >
          {render()}
        </FocusFlow>
      ) : (
        <Sheet
          id={id}
          title={title}
          style={style}
          action={action}
          showLogo={showLogo}
          closeButtonProps={{ id: 'privacyModalCloseIconButton' }}
          noCloseButton={noCloseButton}
          onCloseComplete={onCloseModal}
          {...(!transitionOnClose && { requestClose: onCloseModal })}
          noPadding={noPadding}
          skipFormFocus
          mobileFixedHeight={'90'}
          isOpen={isModalOpen}
          className={noPadding ? 'privacy-sheet-content' : ''}
          headerClassName={'privacy-sheet-header'}
          onBeforeClose={(reason) =>
            !(isFlow && ['backdropClick', 'swipeDown'].includes(reason))
          }
        >
          {render()}
        </Sheet>
      )}
    </ThemeWrapper>
  )
}

PrivacyModal.propTypes = {
  childProps: object,
  children: element,
  hideCloseBtn: bool,
  id: string,
  isFlow: bool,
  isModalOpen: bool,
  onBackButtonClick: func,
  onCloseModal: func,
  shouldShowBackBtn: bool,
  showPPlogo: bool,
  slides: arrayOf(element),
  transitionOnClose: bool,
}

export default PrivacyModal
